import React from 'react';
import pencil from '../../../assets/images/pencil-round.svg';

export default function Pencilround() {
  return (
    <div >
      <img src={pencil} alt="" onClick={e => { alert("I am an alert box!") }} />
    </div>
  )
}